/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Ctadesc1Inputs */

const zh_about_ctadesc1 = /** @type {(inputs: About_Ctadesc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加入 StudyOS，体验 AI 赋能的全新教学方式。`)
};

const en_about_ctadesc1 = /** @type {(inputs: About_Ctadesc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join StudyOS and experience a new way of teaching powered by AI.`)
};

const es_about_ctadesc1 = /** @type {(inputs: About_Ctadesc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Únete a StudyOS y experimenta una nueva forma de enseñar impulsada por IA.`)
};

/**
* | output |
* | --- |
* | "Join StudyOS and experience a new way of teaching powered by AI." |
*
* @param {About_Ctadesc1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const about_ctadesc1 = /** @type {((inputs?: About_Ctadesc1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Ctadesc1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_about_ctadesc1(inputs)
	if (locale === "en") return en_about_ctadesc1(inputs)
	return es_about_ctadesc1(inputs)
});
export { about_ctadesc1 as "about_ctaDesc" }